import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => ({
  footer: {
    padding: '20px 200px',
    backgroundColor: '#292929',
    display: 'flex',
    alignItems: 'center',
    color: '#b9b9b9',
    bottom: 0,
    boxSizing: 'border-box',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '20px 10vw',
    },
  },
  contactFooter: {
    width: '80%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      '& p': {
        marginBlockStart: 0,
        marginBlockEnd: 0,
      },
    },
  },
  copyRight: {
    color: '#fff',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      color: '#fff',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
  iconWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  iconMob: {
    paddingTop: '20px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  infoManagerWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  infoManagerMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
});

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      matches: window.matchMedia('(max-width:960px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.footer}>
        <Grid container style={{ color: '#fff' }} direction="column">
          <Grid container alignItems="center" style={{ fontSize: '20px', fontWeight: 'bold', marginBlockEnd: 0, paddingBottom: '15px' }}>
            {/* <img
              src={'/images/doowon_logo@2x.png'}
              alt={'관광벤처기업'}
              style={{ marginRight: '10px', width: '50px', WebkitTouchCallout: 'none' }}
              onContextMenu={(e) => e.preventDefault()}
            /> */}
            CONTACT US
          </Grid>
          <Grid container alignItems="center">
            <span style={{ fontSize: '18px' }}>㈜두원시스템</span>
          </Grid>
          <Grid container justify="space-between" alignItems="center">
            <p>
              서울시 성동구 연무장17길 14, 503호
              <br />
              (성수동2가 대군인더스타운)
            </p>
            <p className={classes.iconWeb}>
              <img
                src={'/images/ventureBusiness2.png'}
                alt={'관광벤처기업'}
                style={{ marginRight: '20px', WebkitTouchCallout: 'none' }}
                onContextMenu={(e) => e.preventDefault()}
              />
              <img
                src={'/images/femaleBusiness2.png'}
                alt={'여성친화기업'}
                onContextMenu={(e) => e.preventDefault()}
                style={{ WebkitTouchCallout: 'none' }}
              />
            </p>
          </Grid>

          <Grid container justify="space-between" style={{ color: '#fff' }}>
            <Grid container item xs={12} md={6} direction="row" style={{ color: '#fff', paddingTop: '15px' }}>
              <Grid container className={classes.contactFooter}>
                <p>EMAIL: ohydoo@hanmail.net</p>
                <p>TEL. 02-529-5666</p>
                <p>FAX. 02-468-0083</p>
              </Grid>
            </Grid>
            <Grid container item xs={12} md={6} className={classes.copyRight}>
              <p className={classes.infoManagerMobile}>정보책임관리자 : 이은선 (hellsing2432@gmail.com)</p>
              <p>Copyright &copy;DOOWON Corp. ltd All Rights Reserved </p>
            </Grid>
            <p className={classes.iconMob}>
              <img
                src={'/images/ventureBusiness2.png'}
                alt={'관광벤처기업'}
                style={{ marginRight: '30px', WebkitTouchCallout: 'none' }}
                onContextMenu={(e) => e.preventDefault()}
              />
              <img
                src={'/images/femaleBusiness2.png'}
                alt={'여성친화기업'}
                onContextMenu={(e) => e.preventDefault()}
                style={{ WebkitTouchCallout: 'none' }}
              />
            </p>
          </Grid>
          <Grid className={classes.infoManagerWeb}>정보책임관리자 : 이은선 (hellsing2432@gmail.com)</Grid>
        </Grid>
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(Footer));
